<script setup>
import { onMounted, ref } from 'vue';
import {
  useFelixBagAuxStore,
  useVideobotContentStore,
  useGlobalStateStore,
} from '../../../store';
import requestApi from '@/utils/requestApi';

const felixBagAuxStore = useFelixBagAuxStore();
const videobotContentStore = useVideobotContentStore();
const globalStateStore = useGlobalStateStore();

const soundActivated = ref(true);
const subtitleActivated = ref(false);
const librasActivated = ref(false);

const skipButton = ref(false)

var tagVideo, tagTrack;

onMounted(async () => {
  if (process.env.NODE_ENV === 'development') {
    // felixBagAuxStore.seekTo(felixBagAuxStore.scenes.escolha_de_perfil);
  }
  // felixBagAuxStore.rewriteOnDocument();
  window.$('.jb-save').live('click', jbSaveClicked);

  // posiVlibras();
  addSubtitle();
  verificaExpectativaDocumentos();
  jumpIntro();
  firstViewedDate();
  
  await videobotContentStore.load();

  globalStateStore.calcularQtdConteudo(videobotContentStore.videobotContent);
});

globalStateStore.$subscribe(
  () => {
    globalStateStore.load();
  },
  { detached: true }
);

function soundActivate() {
  soundActivated.value = !soundActivated.value;
  if (soundActivated.value) {
    felixBagAuxStore.unmuteVideo();
  } else {
    felixBagAuxStore.muteVideo();
  }
}

async function verificaExpectativaDocumentos() {
  let trilhas = ['gestante', 'parceria']
  if (window.ovmConfig.env['CPF'] && trilhas.includes(window.ovmConfig.env['TRILHA'])) {
    let cpfChave = window.ovmConfig.env['CPF'].toString();
    await requestApi({
      url: `/v2/documents/${cpfChave}`,
      method: "GET",
      headers: {
        BCS: globalStateStore.uuid,
        'Content-Type': 'application/json',
      },
      dataType: 'json'
    }).then(response => {
      if (response.data.result.length !== 0) {
        for (let x = 0; x < response.data.result.length; x++) {
          if (response.data.result[x].type === 'Exame Beta') {
            globalStateStore.exames['EXAME_BETA'] = {
              status: response.data.result[x]._status,
            }
          } else if (response.data.result[x].type === 'Exame Ultrassom') {
            globalStateStore.exames['EXAME_ULTRASSOM'] = {
              status: response.data.result[x]._status,
            }
          }
        }
      }
    }).catch(function (error) {
      console.log(error)
    })
  }
}

function addSubtitle() {
  tagVideo = document.getElementsByTagName('video');
  tagVideo[0].setAttribute('crossorigin', 'anonymous');
  tagTrack = document.createElement('track');
  tagTrack.setAttribute('kind', 'subtitles');
  tagTrack.setAttribute('default', '');
  tagTrack.src =
    './vivo__mais-familia_legenda.vtt';
  tagVideo[0].appendChild(tagTrack);

  for (var i = 0; i < tagVideo[0].textTracks.length; i++) {
    tagVideo[0].textTracks[i].mode = 'hidden';
  }
}

function subtitleActivate() {
  subtitleActivated.value = !subtitleActivated.value;
  tagVideo[0].textTracks[0].mode = subtitleActivated.value
    ? 'showing'
    : 'hidden';
}

// function librasActivate() {
//   if (!librasActivated.value) {
//     document.querySelector('#main-vlibras > div.active').click();
//   } else {
//     window.dispatchEvent(
//       new CustomEvent('vp-widget-close', { detail: { close: true } })
//     ); 
//   }
//   librasActivated.value = !librasActivated.value;
// }

// function posiVlibras() {
//   var origem = document.getElementById('main-vlibras');
//   var destino = document.getElementById('ovm-player');
//   destino.appendChild(origem);
// }

function jbSaveClicked() {
  var source = window.$(this).data('source');
  felixBagAuxStore.saveEvent(source, 'clicked', true);
}

function checkLink() {
  if (window.ovmConfig.env['TRILHA'] === 'LINK_UNICO'){
    return false
  } else {
    return true
  }
}

function firstViewedDate() {
  if (window.ovmConfig.env['TRILHA'] !== 'LINK_UNICO') {
    if (!globalStateStore.globalState.selectedData.firstViewedDate) {
      globalStateStore.globalState.selectedData.firstViewedDate = new Date();
    }
  }
}

function jumpIntro() {
  if (window.ovmConfig.env['TRILHA'] !== "" && window.ovmConfig.env['TRILHA'] !== "LINK_UNICO") {
    if (window.ovmConfig.env['TRILHA'] !== 'LINK_UNICO') {
      if (!globalStateStore.globalState.selectedData.profile){
        if (window.ovmConfig.env['TRILHA']){
          globalStateStore.globalState.selectedData.profile = profileOptions[window.ovmConfig.env['TRILHA']];
        } else {
          globalStateStore.globalState.selectedData.profile = profileOptions[window.ovmConfig.env['PROFILE']];
        }
      }
    }
    felixBagAuxStore.seekTo(felixBagAuxStore.scenes.apresentacao_menu)
  }
  skipButton.value = true
  setTimeout(() => {
    skipButton.value = false
  }, 10000)
}

const profileOptions = {
  gestante: {
    name: 'gestante',
    title: 'Sou Gestante',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/4c7ac1c4-7ced-4298-8fe1-9f9681b9d3df.svg',
    text: "Parabéns pelo momento lindo!"
  },
  fui_gestante: {
    name: 'fui_gestante',
    title: 'Fui Gestante e meu Bebê já nasceu',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/4fcf872c-8e84-450f-9a6b-22ba998bcdd2.svg',
    text: "Seu bebê já chegou? Que maravilha!"
  },
  parceria: {
    name: 'parceria',
    title: 'Sou parceria de gestante',
    img: "//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/7a162795-bcca-4fcd-9da1-3a78c76b3ce1.png",
    text: "Estaremos ao seu lado para te ajudar!"
  },
  parceira_e_bebe_nasceu: {
    name: 'parceira_e_bebe_nasceu',
    title: 'Sou parceria e meu bebê já nasceu',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/ab9b9c87-194e-4b16-bae7-993b37cff4fa.svg',
    text: "Seu bebê já chegou? Que maravilha!"
  },
  processo_adotivo:{
    name: 'processo_adotivo',
    title: 'Estou em processo adotivo',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/8def483e-54f7-4cdd-ac76-e65fe20fb692.svg',
    text: "Parabéns por esta decisão!"
  },
  acolhimento: {
    name: 'acolhimento',
    title: 'Estamos com você',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/250edb9e-a7e0-4a6b-bc90-01dbce5df767.svg',
    text: "Estamos com você"
  },
  processo_adotivo_chegou: {
    name: 'processo_adotivo_chegou',
    title: 'Estou em processo adotivo',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/8def483e-54f7-4cdd-ac76-e65fe20fb692.svg',
    text: "Parabéns por esta decisão!"
  }
}

function skipIntro() {
  skipButton.value = false
  if (window.ovmConfig.env['TRILHA'] === 'LINK_UNICO') {
    felixBagAuxStore.seekTo(felixBagAuxStore.scenes.escolha_de_perfil)
  } else {
    felixBagAuxStore.seekTo(felixBagAuxStore.scenes.menu)
  }
}
</script>

<template>
  <div id="general">

    <v-btn v-if="skipButton" flat @click="skipIntro()" style="background: #bc4aff; color: #fff; position: absolute; top: 10%; right: 5%;" class="btn-cadastro text-none"> Pular introdução </v-btn>

    <nav class="control-bar">
      <button class="iten-control" id="mute" role="checkbox" aria-checked="false" aria-label="Mute video"
        v-on:click="soundActivate()" :class="soundActivated ? '' : 'active'">
        <svg xmlns="http://www.w3.org/2000/svg" width="62.002" height="61.818" viewBox="0 0 62.002 61.818">
          <path id="icon_menu_-_som" data-name="icon menu - som"
            d="M412.582,84.262V67.43a10.269,10.269,0,0,1,2.815,3.724,11.51,11.51,0,0,1,0,9.385,10.327,10.327,0,0,1-2.815,3.723M408.465,101.7l-14.638-8.932a9,9,0,0,1-4.312-7.682V66.61a9,9,0,0,1,4.312-7.683l14.638-8.933ZM381.013,83.235a2.355,2.355,0,0,1-2.389-1.96c-.075-.512-.14-1.03-.219-1.586a27.164,27.164,0,0,1-.273-3.844,25.77,25.77,0,0,1,.273-3.784c.036-.242.074-.485.116-.729a3.75,3.75,0,0,1,3.764-3.055H385.4V83.235h-4.386Zm31.57-20.829V48.48a3.391,3.391,0,0,0-.968-2.452,2.915,2.915,0,0,0-2.119-1,2.568,2.568,0,0,0-.758.122,4.114,4.114,0,0,0-.823.364L389.627,56.72a8.868,8.868,0,0,0-4.234,7.56h-3.35a7.315,7.315,0,0,0-7.428,5.543,29.643,29.643,0,0,0-.6,6.023,30.091,30.091,0,0,0,.6,6.054,7.406,7.406,0,0,0,7.516,5.635H385.4a8.956,8.956,0,0,0,4.29,7.644L407.915,106.3a2.907,2.907,0,0,0,.818.424,2.536,2.536,0,0,0,.758.122,2.927,2.927,0,0,0,2.18-.938,3.458,3.458,0,0,0,.909-2.513V89.47A15.269,15.269,0,0,0,418.3,83.9a14.894,14.894,0,0,0,2.214-7.872A15.769,15.769,0,0,0,412.582,62.4Zm15.286-8.521a2.1,2.1,0,0,0-2.964.008,2.215,2.215,0,0,0-.048,3.022,31.938,31.938,0,0,1,2.258,2.886,27.768,27.768,0,0,1,2.633,4.966,29.281,29.281,0,0,1,2.149,11.08,29.863,29.863,0,0,1-.544,5.692,28.885,28.885,0,0,1-1.6,5.388,28.067,28.067,0,0,1-2.638,4.964,31.875,31.875,0,0,1-2.266,2.9,2.195,2.195,0,0,0,.048,3,2,2,0,0,0,2.921-.058,37.358,37.358,0,0,0,2.687-3.477,35.9,35.9,0,0,0,3-5.721,34.393,34.393,0,0,0,1.906-6.205,32.79,32.79,0,0,0-1.906-19.162,35.7,35.7,0,0,0-3-5.721c-1.225-1.791-.976-1.86-2.492-3.413Zm-5.424,5.56A1.987,1.987,0,0,0,419.5,59.3a2.139,2.139,0,0,0-.059,2.881,21.653,21.653,0,0,1,3.373,5.523,20.877,20.877,0,0,1,1.635,8.143,21.307,21.307,0,0,1-1.635,8.2,20.218,20.218,0,0,1-3.283,5.4,2.233,2.233,0,0,0,.046,3.015,1.951,1.951,0,0,0,2.88-.075q.961-1.145,1.808-2.38a27.405,27.405,0,0,0,2.362-4.419,24.22,24.22,0,0,0,1.453-4.783,22.6,22.6,0,0,0,.544-4.966,22.838,22.838,0,0,0-.544-5.026,24.329,24.329,0,0,0-1.453-4.778,25.179,25.179,0,0,0-2.362-4.359,14.077,14.077,0,0,0-1.753-2.148Z"
            transform="translate(-374.015 -45.028)" />
        </svg>

        <span>Som</span>
      </button>
      <button class="iten-control" id="subtitle" role="checkbox" aria-checked="false" aria-label="Legendar video"
        v-on:click="subtitleActivate()" :class="subtitleActivated ? 'active' : ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="65.75" height="61.077" viewBox="0 0 65.75 61.077">
          <path id="icon_menu_-_legenda" data-name="icon menu - legenda"
            d="M697.224,46.875H652.83a8.2,8.2,0,0,0-8.178,8.178V83.091a8.2,8.2,0,0,0,8.178,8.178h5.841v11.683l13.686-11.411a1.17,1.17,0,0,1,.75-.272h24.117a8.2,8.2,0,0,0,8.178-8.178V55.053A8.2,8.2,0,0,0,697.224,46.875Z"
            transform="translate(-642.152 -44.375)" fill="none" stroke-linecap="round" stroke-linejoin="round"
            stroke-width="5" />
        </svg>

        <span>Legenda</span>
      </button>
      <button class="iten-control" id="Libras" role="checkbox" aria-checked="false" aria-label="Audio descrição video"
        :class="librasActivated ? 'active' : ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="62.006" height="59.688" viewBox="0 0 62.006 59.688">
          <path id="icon_menu_-_libras" data-name="icon menu - libras"
            d="M932.606,96.469a17.047,17.047,0,0,1-7.137-1.511,19.1,19.1,0,0,1-9.92-10.164,18.592,18.592,0,0,1-1.511-7.435V62.6a5.333,5.333,0,0,1,1.573-3.93,5.127,5.127,0,0,1,3.75-1.573H920l.575.122V55.894a5.333,5.333,0,0,1,1.573-3.93,5.128,5.128,0,0,1,3.75-1.573h.7l.515.182a6.1,6.1,0,0,1,1.935-3.3,5.16,5.16,0,0,1,3.569-1.36,5.248,5.248,0,0,1,2.661.7,6.016,6.016,0,0,1,2,1.844q.545-.122,1.059-.211a5.988,5.988,0,0,1,1-.091,5.089,5.089,0,0,1,3.779,1.573,5.388,5.388,0,0,1,1.536,3.931v12.4a2.036,2.036,0,0,1-.575,1.451,2.116,2.116,0,0,1-2.965,0,2.036,2.036,0,0,1-.575-1.451v-12.4a1.527,1.527,0,0,0-.333-.968,1.059,1.059,0,0,0-.387-.319,1.079,1.079,0,0,0-.49-.1,1.159,1.159,0,0,0-.848.364,1.391,1.391,0,0,0-.364,1.028V68.409a2.059,2.059,0,1,1-4.115,0V51.417a1.527,1.527,0,0,0-.333-.968,1.059,1.059,0,0,0-.387-.319,1.079,1.079,0,0,0-.49-.1,1.478,1.478,0,0,0-.937.364,1.245,1.245,0,0,0-.453,1.028V68.409a2.059,2.059,0,1,1-4.115,0V55.894a1.527,1.527,0,0,0-.333-.968,1.06,1.06,0,0,0-.387-.319,1.1,1.1,0,0,0-1.338.319,1.444,1.444,0,0,0-.364.968V70.646a2.058,2.058,0,1,1-4.114,0V62.784a1.527,1.527,0,0,0-.333-.968,1.06,1.06,0,0,0-.874-.422,1.158,1.158,0,0,0-.848.364,1.391,1.391,0,0,0-.364,1.028V77.539a14.756,14.756,0,0,0,1.149,5.805,15.68,15.68,0,0,0,3.114,4.778,13.978,13.978,0,0,0,4.627,3.2,13.036,13.036,0,0,0,5.564,1.209,8.43,8.43,0,0,0,1.391-.122q.726-.121,1.391-.242a2.15,2.15,0,0,1,1.511.333,1.938,1.938,0,0,1,.908,1.24,2.164,2.164,0,0,1-.333,1.542,1.754,1.754,0,0,1-1.24.817q-1.027.122-1.966.242a14.756,14.756,0,0,1-1.844.122Zm11.913,9.132a6.842,6.842,0,0,1-1.391-.151,4.142,4.142,0,0,1-1.391-.575,4.907,4.907,0,0,1-1.935-1.966,6.719,6.719,0,0,1-.786-2.63q-.544-.182-1.028-.333a4.54,4.54,0,0,1-.908-.393,5.344,5.344,0,0,1-1.873-7.377l9.314-16.147.06-.122-.06-.242a1.275,1.275,0,0,0-.273-.151l-.091-.031-6.349,1.693a5.547,5.547,0,0,1-4.143-.515,4.693,4.693,0,0,1-2.388-3.236,5.059,5.059,0,0,1,.393-3.779,5.142,5.142,0,0,1,2.872-2.57L952.26,60h.122a17.889,17.889,0,0,1,7.288-.544,19.182,19.182,0,0,1,7.046,2.419,18.25,18.25,0,0,1,5.564,4.96,19.246,19.246,0,0,1,3.114,6.44,19.008,19.008,0,0,1,.515,7.166,17.925,17.925,0,0,1-2.359,7.075l-7.2,12.577a5.339,5.339,0,0,1-1.391,1.542,7.008,7.008,0,0,1-1.875,1,3.7,3.7,0,0,1-2.146.211,6.372,6.372,0,0,1-1.966-.695,1.9,1.9,0,0,1-.544-.333,1.9,1.9,0,0,0-.544-.333l-.666.848a5.344,5.344,0,0,1-7.377,1.873,2.473,2.473,0,0,1-.515-.364c-.182-.161-.354-.323-.515-.484a7.549,7.549,0,0,1-1.269,1.119,5.369,5.369,0,0,1-1.511.757,1.859,1.859,0,0,1-.757.3,5.051,5.051,0,0,1-.757.06Zm2.541-12.217-3.569,6.17a1.22,1.22,0,0,0-.151,1,1.421,1.421,0,0,0,.635.757,1.493,1.493,0,0,0,.515.151c.182.019.354.03.515.031q.242-.181.393-.3c.1-.079.212-.159.333-.242l8.224-14.457a1.742,1.742,0,0,1,1.24-1,1.679,1.679,0,0,1,1.542.333,1.779,1.779,0,0,1,.612.511,1.76,1.76,0,0,1,.325.729,1.639,1.639,0,0,1-.273,1.482l-6.168,10.7a.8.8,0,0,0-.182.484v.544a2.263,2.263,0,0,0,.242.393,2.979,2.979,0,0,0,.242.273,1.486,1.486,0,0,0,1,.122,1.245,1.245,0,0,0,.757-.666l7.2-12.519a1.921,1.921,0,0,1,.524-.64,1.948,1.948,0,0,1,.745-.36,1.733,1.733,0,0,1,1.511.273,2.069,2.069,0,0,1,.968,1.269,1.577,1.577,0,0,1-.3,1.511l-3.93,6.713a1.131,1.131,0,0,0-.186.467,1.118,1.118,0,0,0,.035.5,1.179,1.179,0,0,0,.635.726,1.5,1.5,0,0,0,.515.151c.182.019.354.03.515.031a2.267,2.267,0,0,0,.393-.242c.1-.08.212-.161.333-.242l7.2-12.579a14.158,14.158,0,0,0,1.815-5.564,15.173,15.173,0,0,0-.424-5.564,14.843,14.843,0,0,0-2.419-5.02,13.982,13.982,0,0,0-4.294-3.81,14.972,14.972,0,0,0-5.322-1.784,16.367,16.367,0,0,0-5.686.211L935.391,71.01a.988.988,0,0,0-.635.575,1.53,1.53,0,0,0-.091,1,1.329,1.329,0,0,0,.635.726,1.275,1.275,0,0,0,.937.122l6.349-1.753a4.232,4.232,0,0,1,2.6.091,4.4,4.4,0,0,1,2.057,1.482,4.341,4.341,0,0,1,.877,2.419,5.009,5.009,0,0,1-.515,2.6l-9.314,16.146a1.368,1.368,0,0,0-.122.968,1.074,1.074,0,0,0,.666.726,1.112,1.112,0,0,0,.467.186,1.133,1.133,0,0,0,.5-.035,1.179,1.179,0,0,0,.726-.635l7.257-12.579a1.742,1.742,0,0,1,1.24-1,1.539,1.539,0,0,1,1.482.333,1.742,1.742,0,0,1,1,1.24,1.631,1.631,0,0,1-.273,1.482l-4.173,8.29ZM965.5,58.127a2.018,2.018,0,0,1-.786-.151,1.867,1.867,0,0,1-.606-.393,9.824,9.824,0,0,0-4.536-2.237,8.625,8.625,0,0,0-4.96.364,2.078,2.078,0,0,1-1.511-.091,1.723,1.723,0,0,1-1.028-1.119,2.145,2.145,0,0,1,.091-1.542,1.928,1.928,0,0,1,1.119-1.059,14.258,14.258,0,0,1,13.728,2.782,2.017,2.017,0,0,1,.453,1.3,1.771,1.771,0,0,1-.635,1.42,1.267,1.267,0,0,1-.606.575,1.888,1.888,0,0,1-.726.151Zm-37.371,45.417a10.453,10.453,0,0,1-1.784-.151q-.878-.151-1.784-.393a13.505,13.505,0,0,1-4.507-2.146,14.216,14.216,0,0,1-3.417-3.537,1.884,1.884,0,0,1-.333-1.6,2.368,2.368,0,0,1,.817-1.3,1.884,1.884,0,0,1,1.6-.333,2.687,2.687,0,0,1,1.36.817,9.256,9.256,0,0,0,5.5,3.992,7.2,7.2,0,0,0,1.573.3q.787.06,1.693.06a1.61,1.61,0,0,1,1.511.393,2.422,2.422,0,0,1,.726,1.482,1.744,1.744,0,0,1-.453,1.511,2.422,2.422,0,0,1-1.482.726,1.376,1.376,0,0,0-.484.091,1.528,1.528,0,0,1-.544.091Z"
            transform="translate(-914.036 -45.912)" />
        </svg>

        <span>Libras</span>
      </button>
      <button
        v-if="checkLink()"
        @click="felixBagAuxStore.seekTo(felixBagAuxStore.scenes.menu)"
        class="iten-control" id="menu" role="checkbox" aria-checked="false" aria-label="Abrir menu do video">
        <svg xmlns="http://www.w3.org/2000/svg" width="66.094" height="59.688" viewBox="0 0 66.094 59.688">
          <path id="icon_menu_-_home" data-name="icon menu - home"
            d="M54.08,61.249H39.77a2.081,2.081,0,0,1-1.58-.646,2.168,2.168,0,0,1-.613-1.547V38.5H28.424V59.057a2.164,2.164,0,0,1-.613,1.547,2.09,2.09,0,0,1-1.58.646H11.73a5.457,5.457,0,0,1-4-1.677,5.531,5.531,0,0,1-1.677-4.061V34.822A4.983,4.983,0,0,1,3.284,34.6a4.629,4.629,0,0,1-1.611-1.064A4.431,4.431,0,0,1,.417,31.792,5.943,5.943,0,0,1,0,29.535a5.772,5.772,0,0,1,.419-2.192,5.619,5.619,0,0,1,1.256-1.869l.13-.194L28.81,3.108a5.546,5.546,0,0,1,4-1.547,5.77,5.77,0,0,1,4.061,1.547L64,25.668l.1.033.1.161a6.331,6.331,0,0,1,1.58,2.708A6.194,6.194,0,0,1,66,31.536a4.273,4.273,0,0,1-.934,1.869,3.258,3.258,0,0,1-1.644,1.031,6.9,6.9,0,0,1-1.772.419,8.021,8.021,0,0,1-1.9-.033V55.7a5.308,5.308,0,0,1-1.677,3.867,5.468,5.468,0,0,1-4,1.677h0ZM41.963,56.8H54.08a1.219,1.219,0,0,0,1.289-1.289V32.245a2.362,2.362,0,0,1,.033-1.161,1.8,1.8,0,0,1,.677-1.031,2.338,2.338,0,0,1,1.064-.516,1.906,1.906,0,0,1,1.192.13,6.575,6.575,0,0,0,1.547.516,4.76,4.76,0,0,0,1.741.064,2.563,2.563,0,0,0-.161-.74,1.866,1.866,0,0,0-.419-.74L33.908,6.4l-.1-.033-.1-.161a1.479,1.479,0,0,0-2,0l-.194.194L4.775,28.572a1.485,1.485,0,0,0-.258.388,1.306,1.306,0,0,0-.13.58,1.137,1.137,0,0,0,.13.516,1.557,1.557,0,0,0,.258.388q.128.13.806-.033a8.144,8.144,0,0,0,1.772-.74,1.652,1.652,0,0,1,1.256-.291,3.081,3.081,0,0,1,1.322.483,2.108,2.108,0,0,1,.677,1.1,2.916,2.916,0,0,1,.033,1.289V55.707A1.219,1.219,0,0,0,11.93,57H23.853V38.111a4.073,4.073,0,0,1,4-4H37.967a4.073,4.073,0,0,1,4,4V56.8Z"
            transform="translate(0.002 -1.561)" />
        </svg>

        <span>Menu</span>
      </button>
      <button class="iten-control" id="btn-suporte" role="checkbox" aria-checked="false" aria-label="Suporte video"
        @click="felixBagAuxStore.showInteractive('menu-suporte')">
        <svg xmlns="http://www.w3.org/2000/svg" width="61.179" height="61.178" viewBox="0 0 61.179 61.178">
          <g id="icon_menu_-_suporte" data-name="icon menu - suporte" transform="translate(-4690.337 -9873.787)">
            <path id="Caminho_3" data-name="Caminho 3"
              d="M157.771,83.688a2.474,2.474,0,0,1,.446-1.648,4.507,4.507,0,0,1,.283-.418,21.878,21.878,0,0,0,3.727-12.195c.041-12.451-10.465-22.552-23.457-22.552-11.33,0-20.783,7.711-23,17.947a21.743,21.743,0,0,0-.5,4.619,22.908,22.908,0,0,0,23.092,22.836,27.792,27.792,0,0,0,6.374-1.04c1.526-.419,3.039-.972,3.43-1.121a3.571,3.571,0,0,1,1.256-.229,3.509,3.509,0,0,1,1.364.27l7.657,2.714a1.818,1.818,0,0,0,.527.135,1.08,1.08,0,0,0,1.08-1.08,1.738,1.738,0,0,0-.067-.365Z"
              transform="translate(4586.789 9829.412)" fill="none" stroke-linecap="round" stroke-miterlimit="10"
              stroke-width="5" />
            <path id="Caminho_4" data-name="Caminho 4"
              d="M108.542,71.723A19.748,19.748,0,0,0,109.4,92.34c.312.471.487.836.433,1.081s-1.611,8.355-1.611,8.355a1.081,1.081,0,0,0,.366,1.037,1.108,1.108,0,0,0,.7.24.967.967,0,0,0,.393-.081L117.274,100a2.12,2.12,0,0,1,1.62.027,22.87,22.87,0,0,0,8.215,1.621,21.506,21.506,0,0,0,10.81-2.9"
              transform="translate(4586.789 9829.412)" fill="none" stroke-linecap="round" stroke-miterlimit="10"
              stroke-width="5" />
          </g>
        </svg>

        <span>Suporte</span>
      </button>
    </nav>
  </div>
</template>

<style>
#general {}

#general .control-bar {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 10%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 4;
  background: #f3f3f3
}

#general .iten-control {
  background: #f3f3f3;
  border: none;
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 8px;
  justify-content: center;
  color: #707070;
}

#general .iten-control:hover,
#general .iten-control:hover>svg {
  background: #cedce6;
}

#general .iten-control.active,
#general .iten-control.active>svg {
  background: #225492;
  color: #fff;
  fill: #fff !important;
  stroke: #fff !important;
}

#general .iten-control>svg {
  width: 30%;
  height: 51%;
  fill: #464646;
  stroke: #464646;
}

#ovm-vi-interactive-root ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 8px;
}

#ovm-vi-interactive-root ::-webkit-scrollbar-track {
  background: #e6e6e6;
  border-radius: 6px;
}

#ovm-vi-interactive-root ::-webkit-scrollbar-track-piece {
  background: #e6e6e6;
  border-radius: 4px;
}

#ovm-vi-interactive-root ::-webkit-scrollbar-thumb {
  background: #225492;
  border-radius: 6px;
}

#main-vlibras {
  position: absolute !important;
  right: 0% !important;
  top: 77.7% !important;
  margin-top: 0 !important;
}

#main-vlibras > div:nth-child(2).active {
  height: 158px !important;
  background: rgb(235 235 235 / 0%) !important;
}
#main-vlibras > div:nth-child(2) {
  width: 150px !important;
  -moz-border-radius: 0px !important;
  -webkit-border-radius: 0px !important;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0) !important;
  -moz-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0) !important;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0) !important;
}
#main-vlibras > div:nth-child(2) > div {
  min-width: 150px !important;
  min-height: 156px !important;
}
#gameContainer {
  min-height: calc(0.7 * 225px) !important;
  min-width: calc(0.9 * 150px) !important;
}
#\#canvas {
  top: -12px !important;
  min-height: calc(0.7 * 225px) !important;
  min-width: calc(0.9 * 150px) !important;
}

[vw] .access-button {
  display: none;
}
[vw] [vw-access-button] {
  display: none !important;
}
.vpw-box {
  background-color: transparent !important;
}
div.vpw-controls.vpw-subtitles.vpw-playing {
  display: none !important;
}
div.vpw-settings-btn {
  display: none !important;
}
div.vpw-box > span {
  display: none !important;
}
div.vpw-controls.vpw-subtitles.vpw-stopped {
  display: none !important;
}
div.vp-enabled {
  display: none !important;
}
div.vp-disabled {
  display: none !important;
}
div.vp-bounderies {
  display: none !important;
}
@media (max-width: 450px) {
  div#gameContainer {
    display: flex !important ;
    justify-content: center !important ;
    top: 0px !important ;
    left: 0px !important ;
    width: 0% !important ;
    height: 0% !important ;
    background-color: rgb(255 255 255 / 0%) !important;
  }

  .vpw-message-box .vpw-message {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
}
</style>
